import React from 'react';
import { Info } from 'lucide-react';

const PathwayDisclaimer = () => (
  <div className="max-w-3xl mx-auto px-4 py-6 text-center" data-testid="pathway-disclaimer">
    <p className="inline-flex items-start gap-1.5 text-xs text-gray-500 leading-relaxed text-left sm:text-center">
      <Info size={13} className="shrink-0 mt-0.5 text-gray-400" />
      <span>
        <span className="font-semibold text-gray-600">LearnixTa can also make mistakes</span> — reverify outside too.
      </span>
    </p>
  </div>
);

export default PathwayDisclaimer;
